"use client";

import { useEffect } from "react";
import { SessionProvider, useSession } from "next-auth/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/query-client";
import { Toaster } from "@/components/ui/sonner";
import { setAuthToken } from "@/lib/api";

function AuthTokenSync({ children }: { children: React.ReactNode }) {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === "authenticated" && session?.backendAccessToken) {
      // Store backend JWT token for API calls
      setAuthToken(session.backendAccessToken);
    } else if (status === "unauthenticated") {
      // Clear token when logged out
      setAuthToken(null);
    }
  }, [session, status]);

  return <>{children}</>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <AuthTokenSync>
        <QueryClientProvider client={queryClient}>
          {children}
          <Toaster position="top-right" />
        </QueryClientProvider>
      </AuthTokenSync>
    </SessionProvider>
  );
}
